import { ICardFootballCalendar, CardFootballCalendar } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { DataCardCalendarQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<DataCardCalendarQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<DataCardCalendarQuery>): ICardFootballCalendar => {
  return transformer(props);
}

const DataCardCalendarWidget = ({
  props,
  ...rest
}: WidgetContext<ICardFootballCalendar>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CardFootballCalendar {...props} />
    </div>
  );
}

export default DataCardCalendarWidget;